export default __webpack_public_path__ + "static/summer_containers9-69ff1c769c55b777f52412ac445c7caa.webp";